import React, { ReactNode, useEffect, useState } from "react";
import { useRecording } from "../../providers/RecordingProvider";
import {
    DocumentIcon,
    DocumentPlusIcon,
    SquaresPlusIcon,
} from "@heroicons/react/24/solid";

const ActionIndicator: React.FC = () => {
    const { addToVisit, addToDocument, addingTargetNoteTitle } = useRecording();

    const [scribeInfoBoxHeader, setScribeInfoBoxHeader] =
        useState<string>("Create new visit");
    const [scribeInfoBoxBody, setScribeInfoBoxBody] = useState<string>(
        "This recording will create a new visit"
    );
    const [scribeInfoIcon, setScribeInfoIcon] = useState<ReactNode>(
        <DocumentPlusIcon className="h-6 w-6" />
    );

    useEffect(() => {
        if (addToDocument) {
            setScribeInfoBoxHeader("Adding to an existing note");
            setScribeInfoBoxBody(
                `This recording will add to the existing note "${addingTargetNoteTitle ?? ""}".`
            );
            setScribeInfoIcon(<DocumentIcon className="h-5 w-5" />);
        } else {
            if (addToVisit) {
                setScribeInfoBoxHeader("Creating new note");
                setScribeInfoBoxBody(
                    "This recording will result in a new note for this visit."
                );
                setScribeInfoIcon(<DocumentPlusIcon className="h-5 w-5" />);
            } else {
                setScribeInfoBoxHeader("Starting a new visit");
                setScribeInfoBoxBody("This recording will create a new visit.");
                setScribeInfoIcon(<SquaresPlusIcon className="h-5 w-5" />);
            }
        }
    }, [addToVisit, addToDocument, addingTargetNoteTitle]);

    return (
        <div className="inline-flex flex-col sm:flex-row items-center gap-y-2 sm:gap-x-2 bg-blue-50 border border-blue-200 rounded-md px-2 sm:px-4 py-3 shadow-sm mx-2 sm:mx-4 max-w-[calc(100%-1rem)] sm:max-w-none">
            <div className="flex items-center text-blue-600 gap-x-1.5">
                <div className="flex items-center">{scribeInfoIcon}</div>
                <span className="text-xs font-medium">
                    {scribeInfoBoxHeader}
                </span>
            </div>
            <p className="text-xs text-gray-600 text-center sm:text-left">
                {scribeInfoBoxBody}
            </p>
        </div>
    );
};

export default ActionIndicator;
